import axios from "axios";
import { useMutation } from "@tanstack/react-query";
import { API_BASE_PATH, API_BASE_RELATIVE_PATH } from "../Config/Config";

const deleteOuterHtml = async ({ testCaseResultId, testStepResultId }) => {
  try {
    const userDetailsString = localStorage.getItem("userDetail");

    if (!userDetailsString) {
      throw new Error("No User details found in localStorage");
    }


    const response = await axios.post(`
        ${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=deletePassedOuterHTML&testStepResultId=${testStepResultId}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting outer HTML:", error);
    throw error;
  }
};

const useDeleteOuterHtml = (options = {}) => {
  return useMutation({
    mutationFn: deleteOuterHtml,
    ...options,
  });
};

export default useDeleteOuterHtml;
